<div class="cmx-navbar__legal-entity-listing">
  <div class="cmx-navbar__legal-entity-filtering">
    <h2>{{ legalEntity.legalEntityMobileLabel | async }}</h2>
    <div class="cmx-navbar__legal-entity-form">
      <input
        (input)="legalEntity.searchTermChange.emit($event.target.value)"
        [placeholder]="legalEntity.searchPlaceholder | async"
        type="text"
        class="cmx-navbar__legal-entity-input"
        [ngClass]="{ 'cmx-navbar__legal-entity-input--rtl': (layout.direction | async) === 'rtl' }"
      />
      <div
        class="cmx-navbar__legal-entity-icon cmx-icon-search"
        [ngClass]="{ 'cmx-navbar__legal-entity-icon--rtl': (layout.direction | async) === 'rtl' }"
      ></div>
    </div>
  </div>
  <div *ngIf="legalEntity.isLoading | async" class="cmx-navbar__legal-entity-loader">
    <cmx-inline-loader></cmx-inline-loader>
  </div>
  <div *ngIf="!(legalEntity.isLoading | async)" class="cmx-navbar__legal-entity-message">
    {{ legalEntity.message | async }}
  </div>
  <div class="cmx-navbar__legal-entity-list scrollbar" appScroll [scrollCallback]="scrollCallback">
    <div
      *ngFor="let entity of legalEntity.legalEntitiesList | async"
      (click)="preSelect(entity)"
      [id]="entity.legalEntityTypeCode"
      class="cmx-navbar__legal-entity-item"
      [ngClass]="{
        'cmx-navbar__legal-entity-item--active': selectedEntity.legalEntityTypeCode === entity.legalEntityTypeCode
      }"
    >
      <div class="cmx-navbar__legal-entity-name">{{ entity.legalEntityDesc }}</div>
      <div class="cmx-navbar__legal-entity-id">#{{ entity.legalEntityTypeCode }}</div>
    </div>
  </div>
  <div
    class="cmx-navbar__legal-entity-footer"
    [ngClass]="{ 'cmx-navbar__legal-entity-footer--rtl': (layout.direction | async) === 'rtl' }"
  >
    <button (click)="cancel()" class="cmx-button cmx-button--support">{{ buttons.cancelLabel | async }}</button>
    <button (click)="apply()" class="cmx-button">{{ buttons.applyLabel | async }}</button>
  </div>
</div>
